import React, { useState, useEffect, FC } from "react";
import Content from "../../../layout/content/Content";
import { Card } from "reactstrap";
import Head from "../../../layout/head/Head";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  Button,
} from "../../../components/Component";
import { Steps, Step } from "react-step-builder";
import Header from "./Header";
import GeneralDetails from "./GeneralDetails";
import Materials from "./Materials";
import Preview from "./Preview";
import Others from "./Others";
import { useForm, FormProvider, useFormContext } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
const config = {
  before: Header as React.ComponentType<{}> as () => React.ReactElement,
};

const SelfQuotationCreation: FC = () => {
  const [sm, setSm] = useState(false);

  const [mobileView, setMobileView] = useState(false);
  const formMethods = useForm({
    mode: "onChange",
    //  defaultValues: {
    //   rfqId: "RFQ-001",
    //   preferredBrands: "some brand ",
    //   negotiable:"N",
    //   quotationDescription: "some desc of this quotation ",
    //   validityDate: dayjs("2025-09-23T18:30:00.000Z"),

    //   costCenter: "33",
    //   siteId: "149",
    //   contractorId: "40",
    //   approvalRequired: "N",
    //   approvalsData: '{"open":false,"data":[]}',
    //   supplierDocsRequired: "N",
    //   billingAddressId: "22",
    //   paymentTerms: "Cash and Carry",
    //   autoRelease: "Y",
    //   needByDateType: "ORDER_LEVEL",
    //   deliveryAddressType: "ORDER_LEVEL",
    //   deadlineType: "SOFT",
    //   deliveryAddressId: "24",
    //   items: [],
    // },
  });
  const { watch, register, reset, setValue } = formMethods;

  const viewChange = () => {
    if (window.innerWidth < 990) {
      setMobileView(true);
    } else {
      setMobileView(false);
      setSm(false);
    }
  };
  useEffect(() => {
    viewChange();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    const headerClick = () => setSm(false);
    document
      .getElementsByClassName("nk-header")[0]
      ?.addEventListener("click", headerClick);

    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
      document
        .getElementsByClassName("nk-header")[0]
        ?.removeEventListener("click", headerClick);
    };
  }, []);
  return (
    <>
      <Head title="New Invoice" />
      <Content>
        <Card className="card-bordered">
          <div className="card-aside-wrap">
            <div className="card-inner card-inner-lg">
              {sm && mobileView && (
                <div
                  className="toggle-overlay"
                  onClick={() => setSm(!sm)}
                ></div>
              )}
              <BlockHead size="lg">
                <BlockBetween>
                  <BlockHeadContent>
                    <BlockTitle tag="h4">New Quotation</BlockTitle>
                  </BlockHeadContent>
                  <Link to={`${process.env.PUBLIC_URL}/view-rfqs`}>
                    <Button
                      outline
                      className="bg-white d-none d-sm-inline-flex"
                    >
                      <Icon name="arrow-left"></Icon>
                      <span>Back</span>
                    </Button>
                    <Button
                      outline
                      className="btn-icon bg-white d-inline-flex d-sm-none"
                    >
                      <Icon name="arrow-left"></Icon>
                    </Button>
                  </Link>
                  <BlockHeadContent className="align-self-start d-lg-none">
                    <Button
                      className={`toggle btn btn-icon btn-trigger mt-n1 ${
                        sm ? "active" : ""
                      }`}
                      onClick={() => setSm(!sm)}
                    >
                      <Icon name="menu-alt-r" />
                    </Button>
                  </BlockHeadContent>
                </BlockBetween>
              </BlockHead>
              <Block className="mt-1">
                <div className="nk-wizard nk-wizard-simple is-alter wizard clearfix">
                  <FormProvider {...formMethods}>
                    <Steps config={config}>
                      <Step component={GeneralDetails} />
                      <Step component={Materials} />
                      <Step component={Others} />
                      <Step component={Preview} />
                    </Steps>
                  </FormProvider>
                </div>
              </Block>
            </div>
          </div>
        </Card>
      </Content>
    </>
  );
};

export default SelfQuotationCreation;
